import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "heading" }
const _hoisted_4 = {
  id: "gender",
  class: "mb-3"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "mx-3 my-2"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = {
  key: 0,
  class: "mx-3 my-2"
}
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = {
  key: 0,
  class: "mx-3 my-2"
}
const _hoisted_11 = {
  id: "connect_witn_other",
  class: "mb-3 d-flex justify-content-end"
}
const _hoisted_12 = { class: "link-small text-primary-blue" }
const _hoisted_13 = {
  key: 0,
  class: "d-flex flex-column flex-md-row"
}
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = {
  id: "password1",
  class: "mb-3"
}
const _hoisted_16 = {
  id: "password2",
  class: "mb-3"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

import {
    reactive,
    computed,
    ComputedRef,
  } from 'vue'

  import RadioGroup from '@/components/LoginRegister/common/input_groups/RadioGroup/v1/RadioGroup.vue'
  import TextInput from '@/components/LoginRegister/common/inputs/Text/v1/Text.vue'
  import FieldError from '@/components/LoginRegister/common/FieldError/v1/FieldError.vue'

  import EyeSvg from '@/components/LoginRegister/svg/EyeSvg.vue'
  import CheckSvg from '@/components/LoginRegister/svg/CheckSvg.vue'
  import register_form_mandatory from '@/config/loginRegisterLegacy/register_form_mandatory.config'
  import RegisterForm from '@/model/Form/RegisterForm'
  import * as _ from 'lodash'
  import { GenderEnum as genderEnum } from '@/services/AuthService.interface'
  import loggedInUser from '@/state/loggedInUser'
  import locale from '@/state/locale'

  // Translations
  import { useI18n } from 'vue-i18n'
  interface Props {
    form: RegisterForm
    invalidFields: Set<string>
    showErrors: boolean
    isEmailValid?: boolean
  }
  interface Emits {
    (e: 'updateForm', form: RegisterForm): void
    (e: 'useOtherEmail'): void
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InformationsForm',
  props: {
    form: {},
    invalidFields: {},
    showErrors: { type: Boolean },
    isEmailValid: { type: Boolean }
  },
  emits: ["updateForm", "useOtherEmail"],
  setup(__props: any, { emit: __emit }) {

  const { t } = useI18n()

  const tabOptions = [
    {
      label: t('loginRegister.mister'),
      value: genderEnum.Male,
    },
    {
      label: t('loginRegister.madam'),
      value: genderEnum.Female,
    },
  ]

  // state
  const state = reactive({
    isSeePassword1: false,
    isSeePassword2: false,
  })

  // props
  const props = __props

  // emit
  const emit = __emit

  // computed
  const selected_gender = computed(() => {
    return tabOptions.find(
      gender => gender.value === (props.form && props.form.gender)
    )
  })
  const mandatoryFieldsSet = computed(() => {
    if (props.form instanceof RegisterForm) {
      return register_form_mandatory
    } else {
      throw new TypeError('form has to be instance of RegisterForm')
    }
  })
  const contentProcessed = computed(() => {
    // this simply adds a star if the field is mandatory
    return {
      first_name: `${t('loginRegister.contacts_first_name')}${
        mandatoryFieldsSet.value.has('first_name') ? '*' : ''
      }`,
      last_name: `${t('loginRegister.contacts_last_name')}${
        mandatoryFieldsSet.value.has('last_name') ? '*' : ''
      }`,
      email: `${t('loginRegister.contacts_email')}${
        mandatoryFieldsSet.value.has('email') ? '*' : ''
      }`,
      password1: `${t('loginRegister.contacts_password1')}${
        mandatoryFieldsSet.value.has('password1') ? '*' : ''
      }`,
      password2: `${t('loginRegister.contacts_password2')}${
        mandatoryFieldsSet.value.has('password2') ? '*' : ''
      }`,
    }
  })

  // handlers
  const handleRadioClick = (option: any) => {
    const formClone = _.cloneDeep(props.form)
    formClone.gender = option.value
    emit('updateForm', formClone)
  }
  const handleTextInputChange = (field: string, newValue: string) => {
    const fieldKey = field as keyof RegisterForm
    const formClone = _.cloneDeep(props.form) as any // stupid annoying TS error
    formClone[fieldKey] = newValue
    emit('updateForm', formClone)
  }
  const handleToggleSeePassword = (ref: any) => {
    if (ref === 'password1') state.isSeePassword1 = !state.isSeePassword1
    if (ref === 'password2') state.isSeePassword2 = !state.isSeePassword2
  }
  const handleGenderChange = (option: any) => {
    const formClone = _.cloneDeep(props.form)
    formClone.gender = option.value
    emit('updateForm', formClone)
  }
  const handleUseOtherEmail = () => {
    emit('useOtherEmail')
  }

return (_ctx: any,_cache: any) => {
  return (props.form)
    ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('loginRegister.user_info_your_informations')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(RadioGroup, {
            class: "d-flex flex-row nowrap",
            style: {"width":"250px","gap":"10px"},
            options: tabOptions,
            "selected-option": selected_gender.value,
            onRadioClick: _cache[0] || (_cache[0] = option => handleGenderChange(option))
          }, {
            default: _withCtx(({ option }) => [
              _createTextVNode(_toDisplayString(option.label), 1)
            ]),
            _: 1
          }, 8, ["selected-option"]),
          (props.showErrors && props.invalidFields.has('gender'))
            ? (_openBlock(), _createBlock(FieldError, {
                key: 0,
                text: _unref(t)('user_info_mandatory_field')
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TextInput, {
            disabled: _ctx.isFirstNameDisabled,
            id: 'first_name',
            autocomplete: 'given-name',
            value: props.form.first_name,
            placeholder: contentProcessed.value['first_name'],
            "container-box-border": 
          props.showErrors && props.invalidFields.has('first_name')
            ? '1px solid var(--primary-orange)'
            : undefined
        ,
            onInput: _cache[1] || (_cache[1] = newVal => handleTextInputChange('first_name', newVal))
          }, {
            after: _withCtx(() => [
              (!_ctx.invalidFields.has('first_name') && props.form.first_name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(CheckSvg, {
                      height: 16,
                      width: 16,
                      color: 'var(--primary-green)'
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled", "value", "placeholder", "container-box-border"]),
          (props.showErrors && props.invalidFields.has('first_name'))
            ? (_openBlock(), _createBlock(FieldError, {
                key: 0,
                text: _unref(t)('user_info_mandatory_field')
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextInput, {
            disabled: _ctx.isLastNameDisabled,
            id: 'last_name',
            autocomplete: 'family-name',
            value: props.form.last_name,
            placeholder: contentProcessed.value['last_name'],
            "container-box-border": 
          props.showErrors && props.invalidFields.has('last_name')
            ? '1px solid var(--primary-orange)'
            : undefined
        ,
            onInput: _cache[2] || (_cache[2] = newVal => handleTextInputChange('last_name', newVal))
          }, {
            after: _withCtx(() => [
              (!_ctx.invalidFields.has('last_name') && props.form.last_name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(CheckSvg, {
                      height: 16,
                      width: 16,
                      color: 'var(--primary-green)'
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled", "value", "placeholder", "container-box-border"]),
          (props.showErrors && props.invalidFields.has('last_name'))
            ? (_openBlock(), _createBlock(FieldError, {
                key: 0,
                text: _unref(t)('user_info_mandatory_field')
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(TextInput, {
            id: 'email',
            autocomplete: 'email',
            value: 
          props.form instanceof _unref(RegisterForm)
            ? props.form.email
            : _unref(loggedInUser)?.email
        ,
            placeholder: contentProcessed.value['email'],
            "input-type": 'email',
            "container-box-border": 
          props.showErrors && props.invalidFields.has('email')
            ? '1px solid var(--primary-orange)'
            : undefined
        ,
            disabled: _ctx.isEmailDisabled || true,
            onInput: _cache[3] || (_cache[3] = newVal => handleTextInputChange('email', newVal))
          }, {
            after: _withCtx(() => [
              (!_ctx.invalidFields.has('email') && props.form.email)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(CheckSvg, {
                      height: 16,
                      width: 16,
                      color: 'var(--primary-green)'
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value", "placeholder", "container-box-border", "disabled"]),
          (props.showErrors && props.invalidFields.has('email'))
            ? (_openBlock(), _createBlock(FieldError, { key: 0 }, {
                default: _withCtx(() => [
                  (!props.form.email)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(t)('user_info_mandatory_field')), 1)
                      ], 64))
                    : (!props.isEmailValid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(t)('contacts_email_is_not_valid')), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", {
              role: "button",
              onClick: _withModifiers(handleUseOtherEmail, ["stop"])
            }, _toDisplayString(_unref(t)('loginRegister.contacts_other_email')), 1)
          ])
        ]),
        (props.form instanceof _unref(RegisterForm))
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(TextInput, {
                    id: 'password1',
                    autocomplete: 'new-password',
                    value: props.form.password1,
                    placeholder: contentProcessed.value['password1'],
                    "input-type": state.isSeePassword1 ? 'text' : 'password',
                    "container-box-border": 
              props.showErrors && props.invalidFields.has('password1')
                ? '1px solid var(--primary-orange)'
                : undefined
            ,
                    onInput: _cache[5] || (_cache[5] = newVal => handleTextInputChange('password1', newVal))
                  }, {
                    after: _withCtx(() => [
                      (props.form.password1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            role: "button",
                            onClick: _cache[4] || (_cache[4] = () => handleToggleSeePassword('password1')),
                            class: "mx-3 my-2"
                          }, [
                            _createVNode(EyeSvg, {
                              opacity: state.isSeePassword1 ? 1 : 0.5,
                              color: 'var(--primary-blue)'
                            }, null, 8, ["opacity"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["value", "placeholder", "input-type", "container-box-border"]),
                  (props.showErrors && props.invalidFields.has('password1'))
                    ? (_openBlock(), _createBlock(FieldError, { key: 0 }, {
                        default: _withCtx(() => [
                          (!props.form.password1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(t)('user_info_mandatory_field')), 1)
                              ], 64))
                            : (props.form.password1.length < 8)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_unref(t)('contacts_password_format_lenght')), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(TextInput, {
                    id: 'password2',
                    autocomplete: 'new-password',
                    value: props.form.password2,
                    placeholder: contentProcessed.value['password2'],
                    "input-type": state.isSeePassword2 ? 'text' : 'password',
                    "container-box-border": 
              props.showErrors &&
              (props.invalidFields.has('password2') ||
                (props.form.password2 &&
                  props.form.password1 !== props.form.password2))
                ? '1px solid var(--primary-orange)'
                : undefined
            ,
                    onInput: _cache[7] || (_cache[7] = newVal => handleTextInputChange('password2', newVal))
                  }, {
                    after: _withCtx(() => [
                      (props.form.password2)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            role: "button",
                            onClick: _cache[6] || (_cache[6] = () => handleToggleSeePassword('password2')),
                            class: "mx-3 my-2"
                          }, [
                            _createVNode(EyeSvg, {
                              opacity: state.isSeePassword2 ? 1 : 0.5,
                              color: 'var(--primary-blue)'
                            }, null, 8, ["opacity"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["value", "placeholder", "input-type", "container-box-border"]),
                  (props.showErrors && props.invalidFields.has('password2'))
                    ? (_openBlock(), _createBlock(FieldError, { key: 0 }, {
                        default: _withCtx(() => [
                          (props.form.password2 && props.form.password2.length < 8)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(t)('contacts_password_format_lenght')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(t)('user_info_mandatory_field')), 1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
              props.showErrors &&
              props.form.password2 &&
              props.form.password1 !== props.form.password2
            )
                    ? (_openBlock(), _createBlock(FieldError, { key: 1 }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('contacts_passwords_dont_match')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})